module.exports = __webpack_public_path__ + "static/dashboard@2x-9954bcd14a02e8a06b0b3e3acdb30033.png";